import React from 'react';
import { DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';

export type BaseDropdownListType = {
  className?: string;
  name: string;
  icon?: JSX.Element;
};

type ExtendableProps<T> = {
  className?: string;
  onSelect: (item: T) => void;
  list: T[];
};

const withDropdownList = <T extends BaseDropdownListType>() => {
  return ({ className = '150px', list, onSelect }: ExtendableProps<T>) => {
    return (
      <DropdownList className={className}>
        {list.map((item, index) => (
          <DropdownItem
            key={index}
            onClick={() => onSelect(item)}
            buttonClassName='py-2'
            className={`${item.className} cursor-pointer flex text-[14px] font-medium items-center rounded`}>
            <span className='pr-4'>{item.icon}</span>
            {item.name}
          </DropdownItem>
        ))}
      </DropdownList>
    );
  };
};

export { withDropdownList };
